/**
 * The drive root as Drive names it — "Acme's Drive", else "My Drive" — for
 * surfaces that show a location starting at the root (the pickers' paths).
 */
import { useTranslation } from '@papan/i18n'
import { useNewProject } from './NewProjectContext'

export function useDriveRootLabel(): string {
  const { t } = useTranslation('files')
  const { tenantName } = useNewProject()
  return tenantName?.trim() ? t('driveView.title', { tenant: tenantName.trim() }) : t('driveView.rootFolder')
}
